import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import {YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import AdditionalDriverForm from "./parts/additional-driver-form";
import AddItemButtonComponent from "@components/common/form-controls/buttons/add-item-button";
import {isEditableMode, useFormMode} from "@contexts/FormModeContext";

export const CommonAdditionalDriverForm = function ({
   sectionHeading = 'Additional Drivers',
   data = {
      shouldAddAdditionalDrivers: '',
      additionalDrivers: [],
   },
   
   buttonGroupLabel = 'Would you like to add an additional driver?',
   buttonGroupOnChange,
   
   addAdditionalDriver,
   handleAdditionalDiverPropChange,
   removeAdditionalDiverByIndex,
   
   handleAdditionalDriverAccidentPropChange,
   addAdditionalDriverAccident,
   removeAdditionalDriverAccident,
   
   handleAdditionalDriverConvictionPropChange,
   addAdditionalDriverConviction,
   removeAdditionalDriverConviction,
   
}) {
   
   const {mode} = useFormMode();
   
   let additionalDrivers = Array.isArray(data.additionalDrivers) ? data.additionalDrivers : [];
   
   return (
      <div className={"row additional-driver-form-container"}>
         
         {sectionHeading !== '' &&
            <SectionHeading
               text={sectionHeading}
            />
         }
         
         <ScrollableButtonGroupBlock
            containerCssClass="col-12 py-3 "
            labelText={buttonGroupLabel}
            required={true}
            controlName="shouldAddAdditionalDrivers"
            options={YES_NO_CHOICE_OPTIONS}
            selectedValues={data.shouldAddAdditionalDrivers}
            onChange={buttonGroupOnChange}
         />
         
         {data.shouldAddAdditionalDrivers === 'Yes' && (
            
            
            additionalDrivers?.map((driver, index) => (
               <div key={index} className="col-12">
                  <AdditionalDriverForm
                     
                     driver={driver}
                     index={index}
                     handleAdditionalDiverPropChange={handleAdditionalDiverPropChange}
                     removeAdditionalDiverByIndex={removeAdditionalDiverByIndex}
                     
                     handleAdditionalDriverAccidentPropChange={handleAdditionalDriverAccidentPropChange}
                     addAdditionalDriverAccident={addAdditionalDriverAccident}
                     removeAdditionalDriverAccident={removeAdditionalDriverAccident}
                     
                     handleAdditionalDriverConvictionPropChange={handleAdditionalDriverConvictionPropChange}
                     addAdditionalDriverConviction={addAdditionalDriverConviction}
                     removeAdditionalDriverConviction={removeAdditionalDriverConviction}
                  />
               </div>
            ))
         
         )}
         
         {data.shouldAddAdditionalDrivers === 'Yes' && (
            
            additionalDrivers.length === 0 && (
               <div className="col-12 mb-3 py-3 text-center scrollable text-danger" data-block="additionalDrivers">
                  No additional driver info added yet!
               </div>
            
            )
         
         )}
         
         {isEditableMode(mode) && data.shouldAddAdditionalDrivers === 'Yes' && (
            
            
            <div className="text-center">
               
               {additionalDrivers.length < 3 && (
                  <AddItemButtonComponent
                     text="Add Another Driver"
                     onClick={(e) => addAdditionalDriver()}
                  />
               )}
               
               
            </div>
         
         )}
      
      </div>
   );
   
};

